import global from './global';
import globalStore from '@scripts/global';

const tag = global.application ? global.application + '_' : '';
const engine = require('store/src/store-engine')
const storages = [
    require('store/storages/localStorage'),
    require('store/storages/cookieStorage')
]
const plugins = [
    require('store/plugins/defaults'),
    require('store/plugins/expire')
]
const store = engine.createStore(storages, plugins)
const storage = {
	get(key){
		let a = globalStore.sharedstore.indexOf(key) == -1 ? tag : ''
		return store.get(a+key);
	},
	set(key,value,exp){
		  	let a = globalStore.sharedstore.indexOf(key) == -1 ? tag : '',
				expires = typeof exp == 'number'&&exp>=0 ? exp:86400*30 // exp ==  || 86400  默认30天
			return store.set(a+key, value, expires*1000 + new Date().getTime())
	},
	remove(key){
		let a = globalStore.sharedstore.indexOf(key) == -1 ? tag : ''
		return store.remove(a + key)
	},
	clearAll(){
		return store.clearAll()
	}
}

export default storage;
